module.exports = __webpack_public_path__ + "img/card-star-disable.8edd2849.png";